import * as React from 'react';
import { connect } from 'react-redux';
import ITooltip from './interfaces/tooltip';
import IBookmarkState from './interfaces/bookmarkState';
import { actionCreators } from './redux/actions';
import { createPortal } from 'react-dom';

class Tooltip extends React.Component<any, any> {
    componentDidUpdate(prevProps) {
        if(this.props.display && !prevProps.display) {
            setTimeout(this.autoHide, 3000);
        }
    }

    autoHide = () => {
        if(this.props.display) {
            this.props.toggleTooltip();
        }
    }

    render() {
        let tooltipStyle = { top: 170, right: 100, position:'fixed'};
        let renderContainer =  document.body;
        const bookmarkTooltipRenderContainer = document.getElementById("boomark-tooltip-container");
        if(bookmarkTooltipRenderContainer){
            renderContainer = bookmarkTooltipRenderContainer;
            tooltipStyle = {};
        }

        return (
            createPortal(
                <React.Fragment>
                    {
                        this.props.display
                            ? <div className="bookmarks__tooltip" style={tooltipStyle} role="alert">
                                <label>Favorit sparad</label>
                                <a href="#" className="bookmarks__tooltip-action" onClick={(event) => this.props.toggleCategorizeModal(event)}>Döp om och kategorisera favorit</a>
                            </div>
                            : null
                    }
                </React.Fragment>,
                renderContainer
            )
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        toggleCategorizeModal: (event) => {
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }
            dispatch(actionCreators.toggleTooltip());
            dispatch(actionCreators.toggleCategorizeModal());
        },
        toggleTooltip: () => {
            dispatch(actionCreators.toggleTooltip());
        }
    }
}

const mapStateToProps = (state: IBookmarkState): ITooltip => {
    return { display: state.displayTooltip };
}

export default connect(mapStateToProps, mapDispatchToProps)(Tooltip);